<template>
    <div class="inputContainer" :style="{width: width}" :title="value">
        <input v-bind:style="{'background': background, 'border': border, 'font-weight': fontWeight,
        'font-size': fontSize, 'padding':padding, 'width':autoWidth ? inputWidth : false, 'min-Width':autoWidth ? '165px' : false}"
               :id="id" :value="value" :placeholder="placeholder"
               @input="emitInput" ref="input"
               :disabled="disabled" required :class="{iconPadding: icon}" @keyup.enter="$emit('enter')" @focus="$emit('focus')">
        <span class="label">{{label}}</span>
        <div v-if="icon" class="iconContainer" :class="{leftBorder: iconBorder, pointer: this.$listeners.click}">
            <span class="icon" :class="[icon]"
                  @click="$emit('click')" :style="{color: iconColor, fontSize: iconSize}"></span>
        </div>
        <div v-if="image" class="iconContainer" :class="{leftBorder: iconBorder, pointer: this.$listeners.click}">
            <img class="icon" :src="getImgUrl(image)"
                 @click="$emit('click')" :style="{color: iconColor, fontSize: iconSize}"/>
        </div>
    </div>
</template>

<script>
    export default {
        name: "InputDetail",
        data: function () {
            return {
                inputWidth: 0,
            };
        },
        props: {
            placeholder: String,
            disabled: Boolean,
            label: String,
            icon: String,
            image: String,
            iconColor: String,
            iconBorder: Boolean,
            iconSize: String,
            value: String,
            width: String,
            id: String,
            background: String,
            border: String,
            fontWeight: String,
            fontSize: String,
            padding: String,
            autoWidth: {
                type: Boolean,
                default: false,
            }
        },
        mounted() {
            if(this.autoWidth){
                this.resizeInput(this.value)
            }
        },
        methods: {
            updateValue: function (value) {
                this.$emit('input', value);
            },
            getImgUrl(pic) {
                try {
                    let res = require(`../../assets/images/${pic}`);
                    return res;
                } catch (e) {
                    console.error(e);
                }
            },
            emitInput(event) {
                this.$emit('input', event.target.value);
                if(this.autoWidth){
                    this.resizeInput(event.target.value);
                }
            },
            resizeInput(value) {
                this.inputWidth = value.length + 'ch';
            }
        },
        watch: {
            value: function (val) {
                if(this.autoWidth){
                    this.resizeInput(val);
                }
            },
        }
    }
</script>

<style lang="scss" scoped>
    .inputContainer {
        display: inline-block;
        position: relative;
        width: 100%;
    }

    input {
        padding: 1.1em 0.5em 0.5em 0.5em;
        width: 100%;
        font-size: 1em;
        border: 1px solid #d0d4da;
    }

    input::placeholder {
        color: #ccc;
    }

    input:disabled {
        background: transparent;
        border-color: transparent;
        border-bottom: 1px solid #ccc;
        color: black;
    }

    input.iconPadding {
        padding-right: 3em;
    }

    .label {
        position: absolute;
        left: 0.9em;
        top: 5px;
        font-size: 0.7em;
        color: #777;
        pointer-events: none;
        transition: 0.2s ease all;
    }

    .pointer {
        cursor: pointer;
    }

    .leftBorder {
        border-left: 1px solid #d0d4da;
    }

    .iconContainer {
        position: absolute;
        top: 0;
        right: 0;
        //border-left: 1px solid #a9a9a9;
        width: 47px;
        height: 100%;
    }

    .icon {
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
        right: 0;
        font-size: 2.1em;
    }

    .icon:hover {
        color: #d70364
    }

    .icon:before {
        display: flex;
    }

</style>